import dayjs from "dayjs";

export const formatDateTime = (value: string | null) => {
  if (!value) return "—";
  return dayjs(value).format("D MMM YYYY · HH:mm");
};

export const defaultRateForm = () => ({
  type: "",
  name: "",
  value: "",
  validFrom: dayjs().startOf("minute").format("YYYY-MM-DDTHH:mm"),
  validTill: "",
  jurisdiction: "",
});

export const defaultProfileForm = () => ({
  tax_name: "",
  service_method: "",
  product_item_type: "",
  jurisdiction: "",
});

export const defaultItemTypeForm = () => ({
  name: "",
  description: "",
});

export type RateFormState = ReturnType<typeof defaultRateForm>;
export type ProfileFormState = ReturnType<typeof defaultProfileForm>;
export type ItemTypeFormState = ReturnType<typeof defaultItemTypeForm>;
